import { useTranslation } from 'react-i18next'

import { SignupFormWrapper } from '@pages/Signup/Components/SignupFormWrapper'
import { SignupSections, SignupStep } from '@pages/Signup/Components/SignupStep'

import { Body1 } from '@ui/Typography'
import { Link } from '@ui/components/Link'

import { AccountType } from '@model/AccountType'

import {
  StatusTemplateBody,
  StatusTemplateWrapper,
} from '@shared/templates/StatusTemplate/StatusTemplate'

interface VerifyEmailInfoPageProps {
  step: number
  email?: string
  accountTypeId: AccountType
  totalSteps: number
  onResend(event: React.MouseEvent<HTMLElement>): void
}

export const VerifyEmailInfoPage: React.FC<VerifyEmailInfoPageProps> = (props) => {
  const { step, totalSteps, onResend, email, accountTypeId } = props

  const { t } = useTranslation()

  return (
    <SignupFormWrapper label={t('Sign up.Sign up')}>
      <SignupStep
        subStep={{
          current: step,
          total: totalSteps,
        }}
        label={t('Sign up.Confirm Registration')}
        section={SignupSections.PersonalDetails}
        accountTypeId={accountTypeId}
      />
      <StatusTemplateWrapper>
        <StatusTemplateBody
          id='lead-created-page'
          title={`${t('Sign up.Verify your Email')}!`}
          text={[
            <Body1>
              {t('Sign up.Please check your inbox', { email })}
              <Body1 medium>{t('Sign up.click the verification link to continue')}</Body1>{' '}
              {t('Sign up.Your verification link is active for the next x hours', {
                hours: 72,
              })}
              .
            </Body1>,
            <Body1>
              {t(`Sign up.Didn't get the link`)}?{' '}
              {t('Sign up.Make sure to check your spam folder or')}{' '}
              <Link size='lg' onClick={onResend}>
                {t('Sign up.Resend')}
              </Link>
            </Body1>,
          ]}
          icon='Mail'
        />
      </StatusTemplateWrapper>
    </SignupFormWrapper>
  )
}
